<ion-tabs *ngIf="user$ | async">
    <ion-tab-bar slot="bottom" [ngClass]="{ 'hide-menu': !showTabs }">
        <ion-tab-button tab="projects" (click)="navigateToProjects($event)">
            <ion-icon name="folder"></ion-icon>
            <ion-label>{{ "LIST_PROJECTS.PROJECTS" | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="calendar">
            <ion-icon name="calendar"></ion-icon>
            <ion-label>{{ "NAV.CALENDAR" | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="users/profile">
            <ion-icon name="person"></ion-icon>
            <ion-label>{{ "NAV.PROFILE" | translate }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="users/notifications" class="notifications-wrapper">
            <ion-icon name="notifications" class="notifications"></ion-icon>
            <ion-icon
                *ngIf="notifications$ | async"
                name="ellipse"
                class="notifications-active"
            ></ion-icon>
            <ion-label class="pad-right-10">{{ "NAV.NOTIFICATIONS" | translate }}</ion-label>
        </ion-tab-button>
    </ion-tab-bar>
</ion-tabs>
